module.exports = __webpack_public_path__ + "470fc082a62b42ae0c7c7b3e2b6a5dbf.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/animals/cow.svg
// module id = 83
// module chunks = 0